import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'square-dashed-text',
  size: 24,
  node: [
    ['path', { d: 'M14 21h1', key: 'v9vybs' }],
    ['path', { d: 'M14 3h1', key: '1ec4yj' }],
    ['path', { d: 'M19 3a2 2 0 0 1 2 2', key: '18rm91' }],
    ['path', { d: 'M21 14v1', key: '169vum' }],
    ['path', { d: 'M21 19a2 2 0 0 1-2 2', key: '1j7049' }],
    ['path', { d: 'M21 9v1', key: 'mxsmne' }],
    ['path', { d: 'M3 14v1', key: 'vnatye' }],
    ['path', { d: 'M3 9v1', key: '1r0deq' }],
    ['path', { d: 'M5 21a2 2 0 0 1-2-2', key: 'sbafld' }],
    ['path', { d: 'M5 3a2 2 0 0 0-2 2', key: 'y57alp' }],
    ['path', { d: 'M7 12h10', key: 'b7w52i' }],
    ['path', { d: 'M7 16h6', key: '1vyc9m' }],
    ['path', { d: 'M7 8h8', key: '1jbsf9' }],
    ['path', { d: 'M9 21h1', key: '15o7lz' }],
    ['path', { d: 'M9 3h1', key: '1yesri' }],
  ],
  aliases: ['text-selection', 'text-select'],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name SquareDashedText
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgMjFoMSIgLz4KICA8cGF0aCBkPSJNMTQgM2gxIiAvPgogIDxwYXRoIGQ9Ik0xOSAzYTIgMiAwIDAgMSAyIDIiIC8+CiAgPHBhdGggZD0iTTIxIDE0djEiIC8+CiAgPHBhdGggZD0iTTIxIDE5YTIgMiAwIDAgMS0yIDIiIC8+CiAgPHBhdGggZD0iTTIxIDl2MSIgLz4KICA8cGF0aCBkPSJNMyAxNHYxIiAvPgogIDxwYXRoIGQ9Ik0zIDl2MSIgLz4KICA8cGF0aCBkPSJNNSAyMWEyIDIgMCAwIDEtMi0yIiAvPgogIDxwYXRoIGQ9Ik01IDNhMiAyIDAgMCAwLTIgMiIgLz4KICA8cGF0aCBkPSJNNyAxMmgxMCIgLz4KICA8cGF0aCBkPSJNNyAxNmg2IiAvPgogIDxwYXRoIGQ9Ik03IDhoOCIgLz4KICA8cGF0aCBkPSJNOSAyMWgxIiAvPgogIDxwYXRoIGQ9Ik05IDNoMSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/square-dashed-text
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SquareDashedText = createLucideIcon(__iconData);

export default SquareDashedText;
